import { CookiePreferencesDto } from "../domain-models/user/cookie-preferences-dto";
import { ResponseCachedDecorator } from "./decorators/response-cached.decorator";
import { ResponseResultTypeDecorator } from "./decorators/response-result-type.decorator";
import { GenericServiceResponse } from "./generic-service-response";

@ResponseCachedDecorator()
@ResponseResultTypeDecorator(CookiePreferencesDto)
export class CookiePreferencesResponse extends GenericServiceResponse<CookiePreferencesDto> {

}